import React from "react";
import { Ban, X } from "lucide-react";
import { useI18n } from "@/contexts/LanguageContext";

/**
 * BlockConfirmDialog — clear confirmation for the destructive Block action.
 */
export default function BlockConfirmDialog({ open, onCancel, onConfirm }) {
  const { t } = useI18n();
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-[110] flex items-center justify-center p-4"
      style={{ backgroundColor: "rgba(10,17,40,0.75)", backdropFilter: "blur(6px)" }}
      onClick={onCancel}
      data-testid="block-confirm-overlay"
    >
      <div
        className="max-w-md w-full rounded-2xl p-6"
        style={{ backgroundColor: "hsl(var(--nvl-bg))", border: "1px solid hsl(var(--destructive) / 0.4)" }}
        onClick={(e) => e.stopPropagation()}
        data-testid="block-confirm-dialog"
      >
        <button
          onClick={onCancel}
          aria-label="Close"
          className="float-right opacity-60 hover:opacity-100"
          data-testid="block-confirm-close"
        >
          <X size={16} />
        </button>
        <div
          className="w-11 h-11 rounded-full flex items-center justify-center mb-3"
          style={{ backgroundColor: "hsl(var(--destructive) / 0.12)", color: "hsl(var(--destructive))" }}
        >
          <Ban size={18} />
        </div>
        <h3 className="font-display text-2xl leading-tight" data-testid="block-confirm-title">
          {t("app.moderation.blockConfirmTitle")}
        </h3>
        <p className="mt-2 text-sm" style={{ color: "hsl(var(--nvl-ink-soft))" }}>
          {t("app.moderation.blockConfirmBody")}
        </p>
        <div className="mt-6 flex gap-3 justify-end">
          <button
            onClick={onCancel}
            className="nvl-btn nvl-btn-outline"
            data-testid="block-confirm-cancel"
          >
            {t("app.moderation.cancel")}
          </button>
          <button
            onClick={onConfirm}
            className="nvl-btn"
            style={{ backgroundColor: "hsl(var(--destructive))", color: "hsl(var(--nvl-bg))" }}
            data-testid="block-confirm-cta"
          >
            {t("app.moderation.blockConfirmCta")}
          </button>
        </div>
      </div>
    </div>
  );
}
